import { render, staticRenderFns } from "./FormMultiFileUploaderImageModule.vue?vue&type=template&id=8babc446&"
import script from "./FormMultiFileUploaderImageModule.vue?vue&type=script&lang=ts&"
export * from "./FormMultiFileUploaderImageModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports